import { Chip } from '@mui/material';
import { Cancel } from '@mui/icons-material';

import { SelectAutocomplete } from '../../../../components';
import { FiltersSectionProps } from './FiltersSection.types';

/**
 * Renders filter controls for price processing functionality
 * Provides hierarchical filtering with save/reset capabilities for price changes
 */
export function FiltersSection({
  isMobile,
  regionalOffices,
  provinces,
  brands,
  filters,
  activeFilters,
  hasChanges,
  hasPriceChanges,
  isFiltersLoading,
  onFilterChange,
  removeActiveFilter,
  onResetChanges,
  onSave
}: FiltersSectionProps): JSX.Element {
  return (
    <div className={`price-processing-filter-section ${isMobile ? 'mobile' : ''}`}>
      <div className="price-processing-filter-card">
        <div className={`price-processing-filter-row ${isMobile ? 'mobile' : ''}`}>
          <div className="price-processing-form-field-group">
            <label className="price-processing-field-label">Регіональне відділення *</label>
            <SelectAutocomplete
              options={regionalOffices}
              value={filters.regional_office || ''}
              onChange={value => onFilterChange('regional_office', value)}
              placeholder="Оберіть регіональне відділення..."
            />
          </div>

          <div className="price-processing-form-field-group">
            <label className="price-processing-field-label">Область *</label>
            <SelectAutocomplete
              options={isFiltersLoading ? ['Завантаження...'] : provinces}
              loading={isFiltersLoading}
              value={''}
              onChange={value => onFilterChange('province', value)}
              showClearButton={Array.isArray(filters.province) && filters.province.length > 0}
              onClear={() => removeActiveFilter('province')}
              placeholder="Оберіть область..."
              disabled={!filters.regional_office}
            />
          </div>

          <div className="price-processing-form-field-group">
            <label className="price-processing-field-label">Бренди</label>
            <SelectAutocomplete
              options={isFiltersLoading ? ['Завантаження...'] : brands}
              loading={isFiltersLoading}
              value={''}
              onChange={value => onFilterChange('brand', value)}
              showClearButton={Array.isArray(filters.brand) && filters.brand.length > 0}
              onClear={() => removeActiveFilter('brand')}
              placeholder="Оберіть бренд..."
              disabled={!filters.province}
            />
          </div>
        </div>

        {activeFilters.length > 0 && (
          <div className="price-processing-active-filters">
            {activeFilters.map((filter, index) => (
              <Chip
                key={`${filter.key}-${filter.value}-${index}`}
                label={filter.value}
                onDelete={() => removeActiveFilter(filter.key, filter.value)}
                deleteIcon={<Cancel />}
                className={`price-processing-filter-chip ${filter.key}`}
              />
            ))}
          </div>
        )}

        <div className={`action-buttons ${isMobile ? 'mobile' : ''}`}>
          <button className="action-btn reset-btn" onClick={onResetChanges} disabled={!hasChanges}>
            Скинути зміни
          </button>
          <button className="action-btn save-btn" onClick={onSave} disabled={!hasChanges || !hasPriceChanges}>
            Провести ціни
          </button>
        </div>
      </div>
    </div>
  );
}
